// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/style.css
// module id = 2014
// module chunks = 0